export const stepsToGetLoan = [
  {
    id: "step-one",
    stepName: "What is a Wedding Loan?",
  },
  {
    id: "step-two",
    stepName: "Expenses Covered by Wedding Loans",
  },
  {
    id: "step-three",
    stepName: "Choosing the Right Lender for Your Wedding Loan",
  },
  {
    id: "step-four",
    stepName: "Best Practices When Taking a Wedding Loan",
  },
  {
    id: "step-five",
    stepName: "Comparing Lenders: Features and Offers",
  },
];
